import { render, staticRenderFns } from "./FulfillmentMethodSettings.vue?vue&type=template&id=9bd87c3c&scoped=true&"
import script from "./FulfillmentMethodSettings.vue?vue&type=script&lang=js&"
export * from "./FulfillmentMethodSettings.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentMethodSettings.vue?vue&type=style&index=0&id=9bd87c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd87c3c",
  null
  
)

export default component.exports